<template>
  <div class="container">
  	<div class="button">
  		<!-- <div class="icon"></div> -->
      <i class="icon fab fah fa-lg far" :class="{active: mutableLiked}" @click="toggleLike" aria-hidden="true"></i>
      <RequireLoginModal 
      v-if="showRequiredLoginModal" 
      @cancel="showRequiredLoginModal=false" 
      />
  	</div>

  </div>
  
</template>
<script>
import RequireLoginModal from "../RequireLoginModal.vue";

export default {
  props: {
    liked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mutableLiked: JSON.parse(this.liked),
      showRequiredLoginModal: false,
    };
  },
  methods: {
    toggleLike() {
      if (!this.$auth.check()) {
        this.showRequiredLoginModal = true;
      } else {
        this.mutableLiked = !this.mutableLiked;
        this.$emit("toggleLike", this.mutableLiked);
      }
    },
  },
  components: { RequireLoginModal },
};
</script>
<style scoped lang="scss">
@import "../../styles/variables";

.container {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  margin-block: unset;
}

.button {
  text-align: center;
  /*background: #cccccc;*/
  cursor: pointer;
  font-weight: bold;
}

.icon {
  font-size: 27px;
  vertical-align: bottom;

  // Image
  width: 28px;
  height: 28px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("/img/btn/heart.png");
}


@media (hover: hover) {
  .icon:hover {
    background-image: url("/img/btn/heart-red.png") !important;
  }
}

.icon.active {
  background-image: url("/img/btn/heart-red.png");
}
</style>
